import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    private key = 'color';
    constructor() {}

    get<T>(key: string): T | null {
        const ls: string | null = localStorage.getItem(key);
        if (ls) {
            return JSON.parse(ls) as T;
        }
        return null;
    }

    set<T>(key: string, val: T): void {
        localStorage.setItem(key, JSON.stringify(val));
    }

    remove(key: string): void {
        localStorage.removeItem(key);
    }

    getToken(): string {
        const token = this.get<string>('token');
        if (token === null) {
            return '';
        }
        return this.decrypt(token);
    }

    setToken(token: string): void {
        this.set<string>('token', this.encrypt(token));
    }

    clearToken(): void {
        this.remove('token');
    }
    
    private encrypt(txt: string): string {
        return CryptoJS.AES.encrypt(txt, this.key).toString();
    }
    
    private decrypt(txtToDecrypt: string): string {
        return CryptoJS.AES.decrypt(txtToDecrypt, this.key).toString(CryptoJS.enc.Utf8);
    }
}
